import FundMiniProfile from './FundMiniProfile'

export default FundMiniProfile
